import {Actions, createEffect, ofType} from "@ngrx/effects";
import {RelatedCasesActions} from "../actions";
import {catchError, map, mergeMap} from "rxjs";
import {Injectable} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {ApiError, RelatedCasesService} from "@esa/api";
import {ApiErrorHandlerService} from "../../services";

@Injectable()
export class RelatedCasesEffects {

  getRelatedCasesById$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RelatedCasesActions.getRelatedCasesById),
      mergeMap(({ parentCaseId }) => this._relatedCasesService.getApiRelatedCase1(parentCaseId).pipe(
        map(relatedCases => RelatedCasesActions.getRelatedCasesByIdSuccess({ relatedCases })),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, RelatedCasesActions.createRelatedCaseError());
        })
      ))
    );
  });

  createCaseEntity$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RelatedCasesActions.createRelatedCase),
      mergeMap(({relatedCase}) => this._relatedCasesService.postApiRelatedCase(relatedCase).pipe(
        map(response => {
          this.toastrService.success('Case linked successfully');
          return RelatedCasesActions.createRelatedCaseSuccess();
        }),
        catchError((error: ApiError) => {
          return this.apiErrorHandlerService.handleError(error, RelatedCasesActions.createRelatedCaseError());
        })
      ))
    );
  });

  constructor(
    private actions$: Actions,
    private _relatedCasesService: RelatedCasesService,
    private toastrService: ToastrService,
    private apiErrorHandlerService: ApiErrorHandlerService
  ) {}
}
